import React, { useState } from "react"
import { injectIntl } from "react-intl"
import { withRouter } from "react-router-dom"
import ReactTooltip from "react-tooltip"
import Icon from "../../icon/icon.component"
import FeatureProtectionWrapperMain from "./featureProtectionWrapperMain.component"
import { messages, getMessage, handleClick } from "./helpers.jsx"
import { Intl } from "../../../state/helpers/IntlProps"

type OwnProps = {
    isProtected: boolean
    protectionRule: boolean
    protectedClassName: string
    accountFeatureKey: string
    className: string
    children: JSX.Element
    showLock: boolean
    premium: boolean
    message: string
    to: string
    callback: () => void
    onClose: () => void
    onMouseEnter: () => void
    onMouseLeave: () => void
    onClickProtected: () => void
    onClick: (e: React.MouseEvent) => void
    intl: Intl
}

const AnchorWrapper = (props: OwnProps) => {
    const [displayModal, setDisplayModal] = useState(false)
    const showLock = props.showLock ?? true

    const lockedItem = <span key={"tooltip-container-anchor"} data-tip data-for={"anchorLock-anchor"}>
        <a key={"anchor"} className={props.protectedClassName || "btn"} href="#" onMouseEnter={props.onMouseEnter}
            onMouseLeave={props.onMouseLeave} onClick={(e) => {
                handleClick(e, props, setDisplayModal)
            }}>
            <ReactTooltip place="bottom" className="anchorLock" id={"anchorLock-anchor"} type="warning" effect="solid"
                multiline={true}>
                {getMessage(props.message, props.intl.formatMessage(messages["update_subscription"]))}
            </ReactTooltip>
            <div className='d-inline-flex'>
                {props.children}
                {showLock && <Icon value="lock" className="lock" />}
            </div>
        </a>
    </span>


    const item = <a key={"anchor"} className={props.className} href="#"
        onMouseEnter={props.onMouseEnter}
        onMouseLeave={props.onMouseLeave}
        onClick={(e) => {
            props.onClick(e)
        }}>
        <div>
            {props.children}
        </div>
    </a>

    return (<>
        <FeatureProtectionWrapperMain
            protectionRule={props.protectionRule}
            accountFeatureKey={props.accountFeatureKey}
            isProtected={props.isProtected ?? true}
            displayModal={displayModal}
            premium={props.premium}
            lockedItem={lockedItem}
            message={props.message}
            item={item}
            callback={props.callback || function () {
                return
            }}
            onClickProtected={props.onClickProtected || function () {
                return
            }}
            onClose={() => {
                setDisplayModal(false)
                if (props.onClose) {
                    props.onClose()
                }
            }}
            onClick={props.onClick || function () {
                return
            }}
        >
        </FeatureProtectionWrapperMain>
    </>)


}

export default withRouter(injectIntl(AnchorWrapper))


// WEBPACK FOOTER //
// ./src/common/rich-text/feature-protection-wrappers/anchorWrapper.component.tsx